<template>
    <div :class="computedClass" v-if="buttonsToRender.length > 0">
        <template v-for="(button, index) in buttonsToRender">
            <span class="margin-left-10" v-if="!!button.display">
                <a v-if="!!button.show_confirmation"
                   :href=getUrl(button)
                   :title="button.title"
                   :class=getButtonClass(button)
                   :data-confirmation-link="button.confirmation.link"
                   :data-confirmation-agree="button.confirmation.agree"
                   :data-confirmation-back="button.confirmation.back"
                   @click="handleButtonClick(button)">
                    <span class="btn-label"><i :class=getButtonIcon(button)></i></span>{{getButtonLabel(button)}}
                </a>
                <a v-else
                   :href=getUrl(button)
                   :title="button.title"
                   :class=getButtonClass(button)
                   @click="handleButtonClick(button)">
                    <span class="btn-label"><i :class=getButtonIcon(button)></i></span>{{getButtonLabel(button)}}
                </a>

            </span>
        </template>
    </div>

</template>

<script>

    export default {
        name: 'np-buttons',
        props: {
            buttonsConfig: {
                type: Array,
                note: 'List of Buttons that will be rendered'
            },
            small: {
                default: false,
                type: Boolean
            },
            buttonAlignment: {
                default: 'right',
                type: String
            },
            addClass: {
                default: '',
                type: String
            },
        },
        computed: {
            computedClass: function () {
                let add = this.addClass;
                if(this.buttonAlignment === 'right') {
                    return 'float-end ' + add;
                }
                else if (this.buttonAlignment === 'left') {
                    return 'float-start ' + add;
                }
                return add;
            },
            buttonsToRender: function () {
                let buttons = [];
                if (this.buttonsConfig.length > 0) {
                    this.buttonsConfig.forEach(function (obj, index) {
                        buttons.push(new Button(obj))
                    })
                }
                return buttons;
            },
        },
        methods: {
            getButtonLabel: function (button) {
                let label = button.lang_key !== '' ? this.lang(button.lang_key) : button.label;
                if (label === '') {
                    if (button.type === 'add') {
                        label = 'Add'
                    }
                    if (button.type === 'save') {
                        label = 'Save'
                    }
                    else if (button.type === 'cancel') {
                        label = 'Cancel'
                    }
                    else if (button.type === 'edit') {
                        label = 'Edit'
                    }
                    else if (button.type === 'back') {
                        label = 'Go Back'
                    }
                }
                return label;
            },
            getButtonIcon: function (button) {
                let icon = button.icon;
                if (icon === '') {
                    if (button.type === 'add') {
                        icon = 'fa fa-plus'
                    }
                    else if (button.type === 'save') {
                        icon = 'fa fa-check'
                    }
                    else if (button.type === 'cancel') {
                        icon = 'fa fa-times'
                    }
                    else if (button.type === 'edit') {
                        icon = 'fa fa-pencil'
                    }
                    else if (button.type === 'back') {
                        icon = 'fa fa-arrow-left'
                    }
                }
                return icon;
            },
            getButtonClass: function (button) {
                let but_class = button.class;
                if (but_class === '') {
                    but_class = !!this.small ? 'btn-sm ' : '';
                    if (button.type === 'save') {
                        but_class += 'btn btn-success btn-with-label vueSave'
                    }
                    else if (button.type === 'add') {
                        but_class += 'btn btn-default btn-with-label vueSave'
                    }
                    else if (button.type === 'cancel') {
                        but_class += 'btn btn-danger btn-with-label'
                    }
                    else {
                        but_class += 'btn btn-default btn-with-label'
                    }
                }
                return but_class;
            },
            getUrl: function (tab) {
                let url = '#'
                if (tab.url !== '') {
                    url = tab.url[0] === '/' ? tab.url : '/' + tab.url;
                }
                return url;
            },
            handleButtonClick: function (button) {
                this.$emit('buttonclick', button.button_id)
            },
        },
        components: {}
    };

    class Button {
        constructor(item) {
            this.url = '';
            this.label = '';
            this.lang_key = '';
            this.button_id = '';
            this.icon = '';
            this.title = '';  // hover text
            this.class = '';
            this.type = '';    // allowed: save, cancel, others default
            this.attributes = false;
            this.display = true;
            if (!!item) {
                this.setItem(item);
            }
        }

        setItem(item) {
            let item_keys = Object.keys(item);
            item_keys.map(f => {
                this[f] = item[f]
            });
        }
    }
</script>
